module.exports = __webpack_public_path__ + "assets/img/devicetips.7369e251.gif";